
























import Vue from 'vue'
import TranslationDisplay from '../../components/base/Translation/TranslationDisplay.vue'

export default Vue.extend({
  name: 'Slogan',
  components: { TranslationDisplay },
  props: {
    lift: {
      type: Object,
      required: true
    },
  }
})
